enum TogglesActions {
    TRACK_PLAYHEAD = 'timeline/toggles/TRACK_PLAYHEAD',
}

export { TogglesActions };
